module.exports = __webpack_public_path__ + "static/media/notfound.0daf41f5.jpg";